import { memo, useCallback, useContext, useState } from "react"
import { makeStyles } from '@mui/styles'
import DatePicker from "react-datepicker";
import { Box, Button, Fade, FormControl, FormControlLabel, IconButton, MenuItem, Modal, Radio, RadioGroup, Select, Stack, TextField, Typography } from "@mui/material";
import moment from 'moment';
import { CubeContext } from "@cubejs-client/react";

import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg"
import { FIELD_TYPE_FILTERS, INPUT_TYPE_TEXT_FILTER_TYPES, DATE_INPUT_FILTER_TYPES } from "../../../constants/filterType";
import AsyncSelectInput from "./AsyncSelectInput";
import { CustomTooltip, getReportFilterData } from "../../../utils/Reusables";
import { ReactComponent as IconFilterDelete } from "../../../assets/icons/icon-delete-small.svg"


const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: "50%"
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }
}))
const AdditionalFilterForm = ({conditionType,fieldType, filterObj, fieldList, filterIndex, onFieldChange }) => {
    const classes = useStyles()
    const cubejsApi = useContext(CubeContext).cubejsApi
    const [deletePopup, setDeletePopup] = useState(false)
    //const [filterValues, setFilterValues] = useState(filterObj.values ? filterObj.values : [])

    const asyncFetchFn = useCallback((event, loaderFn, dataFn) => {
        getReportFilterData(event, { filterObj, cubejsApi, loaderFn, dataFn })
    })

    const handleCancelDelete = useCallback(() => {
        setDeletePopup(false)
    })

    const onDeleteFilter = useCallback((e) => {
        setDeletePopup(false)
        onFieldChange(e, 'delete', filterIndex)
    })

    //console.log(fieldList,fieldType)
    return <Box >
            
            <FormControl className="re-form-group" >
                <Box className="re-flex-between">
                    <Typography component={'label'} className="re-formgroup-label-sm" style={{marginBottom: 0}}>{`Configuration ${filterIndex + 1}`}</Typography>
                    <CustomTooltip title="Delete Configuration">
                        <IconButton color="primary" aria-label="Delete Configuration"
                            sx={{ p: 0 }}
                            onClick={() => setDeletePopup(true)}>
                            <IconFilterDelete className="filter-action-icon" />
                        </IconButton>
                    </CustomTooltip>
                </Box>
                <RadioGroup
                    row
                    name="condition"
                    value={conditionType}
                    onChange={e => onFieldChange(e, 'conditionType', filterIndex)}
                >
                    <FormControlLabel className="re-formcontrol-label-sm" disabled={filterIndex != 0} value="and" 
                        control={<Radio className="re-form-checkbox-sm" size="small" />} label="AND" />
                    <FormControlLabel className="re-formcontrol-label-sm" disabled={filterIndex != 0} value="or" 
                        control={<Radio className="re-form-checkbox-sm" size="small" />} label="OR" />
                </RadioGroup>
            </FormControl>
            <FormControl className="re-form-group">
                <Typography component={'label'} className="re-formgroup-label-sm" >Field Name</Typography>
                <Select
                    variant="outlined"
                    className="report_form_ui_input_select text-small pl-0"
                    id={"extra-filterMember-" + filterIndex}
                    value={filterObj.name}
                    onChange={e => onFieldChange(e, 'member', filterIndex)}
                    size='small'
                    IconComponent={DropDownIcon}
                    MenuProps={{
                        classes: {
                            root: `form-select-menu`
                        }
                    }}
                >
                    {
                        fieldList.filter(obj => obj.dataSetType == fieldType).map(obj => (
                            <MenuItem key={`${filterObj.member}-${obj.displayName}`} className={classes.menuDropdownItem + " menu-item-small"} value={obj.name}>{obj.displayName}</MenuItem>
                        ))
                    }
                </Select>
            </FormControl >
            {
                filterObj && filterObj.member &&
                <>
                    <FormControl className="re-form-group">
                        <Typography component={'label'} className="re-formgroup-label-sm" >Operation</Typography>
                        <Select
                            variant="outlined"
                            className="report_form_ui_input_select text-small pl-0"
                            id={"extra-filterOperation-" + filterIndex}
                            value={filterObj.operator}
                            onChange={e => onFieldChange(e, 'operator', filterIndex)}
                            size='small'
                            IconComponent={DropDownIcon}
                            MenuProps={{
                                classes: {
                                    root: `form-select-menu`
                                }
                            }}
                        >
                            {
                                FIELD_TYPE_FILTERS[filterObj.type].map(obj => (
                                    <MenuItem key={`${filterObj.member}-${obj.value}`} className={classes.menuDropdownItem + " menu-item-small"} value={obj.value}>{obj.label}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    {
                        ['set', 'notSet'].indexOf(filterObj.operator) < 0 && (
                            <FormControl className="re-form-group">
                                <>
                                    {
                                        INPUT_TYPE_TEXT_FILTER_TYPES.indexOf(filterObj.operator) > -1 && (
                                            <>
                                                <Typography component={'label'} className="re-formgroup-label-sm" >Value List</Typography>
                                                <TextField
                                                    className="report_form_ui_input text-small"
                                                    id={"operatorvalues-" + filterIndex}
                                                    label=""
                                                    multiline
                                                    maxRows={4}
                                                    value={filterObj.values.join('\n')}
                                                    onChange={e => onFieldChange(e, 'values', filterIndex)}
                                                    variant="outlined"
                                                    size='small'
                                                />
                                            </>
                                        )
                                    }
                                    {
                                        DATE_INPUT_FILTER_TYPES.indexOf(filterObj.operator) > -1 && (
                                            <>
                                                <Typography ccomponent={'label'} className="re-formgroup-label-sm" >Select Date</Typography>
                                                <DatePicker dateFormat="dd/MM/yyyy" className="report_form_ui_input_date" maxDate={new Date()} selected={filterObj.values.length > 0 ? moment(filterObj.values[0]).toDate() : null} onChange={e => onFieldChange(e, 'values', filterIndex)} isClearable={true} />
                                            </>
                                        )
                                    }
                                    {
                                        ['inDateRange', 'notInDateRange'].indexOf(filterObj.operator) > -1 && (
                                            <>
                                                <Typography component={'label'} className="re-formgroup-label-sm" >Select Date Range</Typography>
                                                <DatePicker dateFormat="dd/MM/yyyy" className="report_form_ui_input_date" maxDate={new Date()} selectsRange={true} startDate={filterObj.values[0]} endDate={filterObj.values[1]} onChange={e => onFieldChange(e, 'values', filterIndex)} isClearable={true} />
                                            </>
                                        )
                                    }
                                    {
                                        filterObj.operator == 'equals#true' && (
                                            <>
                                                <Typography component={'label'} className="re-formgroup-label-sm" >Value List</Typography>
                                                <AsyncSelectInput
                                                    fetchFn={asyncFetchFn}
                                                    filterObj={filterObj}
                                                    defaultValue={filterObj.values}
                                                    handleChange={e => onFieldChange(e, 'values', filterIndex)}
                                                />
                                            </>
                                        )
                                    }
                                </>
                            </FormControl>
                        )
                    }
                </>
            }
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className="modal-root"
                open={deletePopup}
                onClose={() => setDeletePopup(false)}
                closeAfterTransition
            >
                <Fade in={deletePopup}>
                    <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                        <Box className="modal-content-simple">
                            <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this Filter ?`}</Typography>
                            <Box className="modal-footer-simple">
                                <Button onClick={handleCancelDelete} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                                <Button onClick={onDeleteFilter} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
                            </Box>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
    </Box>
}

export default memo(AdditionalFilterForm)